module.exports = __webpack_public_path__ + "static/media/figli.5f64af3a.jpg";